import React from 'react';
import Typography from 'kingpin/atoms/Typography';
import { Item } from 'components/SingleItemPicker';

const ExcludeTermedDriversOption = ({
  onSelected,
}: {
  onSelected: () => void;
}) => (
  <>
    <div
      style={{
        borderBottom: `1px solid var(--color-border-secondary)`,
        marginBottom: '8px',
      }}
    />
    <div style={{ marginLeft: '4px' }}>
      <Typography.Header type="H6" color={'var(--color-grey-5)'}>
        Quick Filters
      </Typography.Header>
    </div>
    <Item data-testid="exclude-termed-drivers-option" onClick={onSelected}>
      <Typography.Body type="Body 12" isEllipsis>
        Exclude termed drivers
      </Typography.Body>
    </Item>
    <div
      style={{
        borderBottom: `1px solid var(--color-border-secondary)`,
        marginBottom: '16px',
        marginTop: '8px',
      }}
    />
  </>
);

export default ExcludeTermedDriversOption;
